import { useState } from 'react';
import './CreateItemDialog.css';

const SimilarClientDialog = ({
  isOpen,
  onClose,
  inputName,
  suggestions,
  onSelectSuggestion,
  onCreateNew
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  if (!isOpen) return null;

  const handleOk = () => {
    if (!selectedOption) return;

    if (selectedOption === inputName) {
      onCreateNew();
    } else {
      onSelectSuggestion(selectedOption);
    }
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3 className="similar-client-title">Similar client name found.</h3>
          <button className="dialog-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="dialog-body">
          <div className="similar-client-content">
            <p className="selection-instruction">
              Select the one to use.
            </p>
            
            <div className="radio-options">
              {suggestions.map((suggestion, index) => (
                <label key={index} className="radio-option">
                  <input
                    type="radio"
                    name="clientChoice"
                    value={suggestion}
                    checked={selectedOption === suggestion}
                    onChange={() => setSelectedOption(suggestion)}
                  />
                  <span className="radio-label">{suggestion}
                  </span>
                </label>
              ))}
              
              <label className="radio-option">
                <input
                  type="radio"
                  name="clientChoice"
                  value={inputName}
                  checked={selectedOption === inputName}
                  onChange={() => setSelectedOption(inputName)}
                />
                <span className="radio-label">
                  {inputName}&nbsp;&nbsp;<span className="new-label">(Create New)</span>
                </span>
              </label>
            </div>
            
            <div className="dialog-buttons">
              <button 
                type="button" 
                onClick={onClose}
                className="btn-cancel"
              >
                Cancel
              </button>
              <button 
                type="button" 
                onClick={handleOk}
                className="btn-confirm"
                disabled={!selectedOption}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimilarClientDialog;